/* eslint-disable react/react-in-jsx-scope */
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import { LOGIN_PATH, PUBLIC_PATH, REGISTER_PATH, FORGETPASSWORD } from "../navigationPaths";
import WithoutAuth from "layouts/WithoutAuth";
import ConnexionPage from "pages/connexion/ConnexionPage";
import ErrorPasswordPage from "pages/ErrorPasswordPage/ErrorPasswordPage";

/*
|---------------------------------------------------------------
| Les routes publics
|---------------------------------------------------------------
| Toute page qui ne necessite pas une authentification doit etre ici
|
*/
export const publicRoutes = [
    {
        path: PUBLIC_PATH,
        errorElement: <ErrorBoundary />,
        element: <WithoutAuth />,
        children: [
            {
                path: "",
                element: <ConnexionPage />,
            },
            {
                path: LOGIN_PATH,
                element: <p>Hello from login</p>,
            },
            {
                path: FORGETPASSWORD,
                element: <ErrorPasswordPage />
            },
            {
                path: REGISTER_PATH,
                element: <p>Hello fromo register</p>
            }
        ]
    },
];